module.exports = __webpack_public_path__ + "img/login.f6ff7446.jpeg";